import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { CreateAwardData } from "../../entry/server/game.ts";
import { gameRepo } from "../../repo/game-repo.ts";
import AdminPageTitle from "../admin-pages/admin-page-title.tsx";
import { AppContext } from "../../context/app-context.tsx";
import AwardFormFields, { emptyAwardForm, isAwardFormValid } from "./award-form-fields.tsx";

export default function NewAward() {
  const navigate = useNavigate();
  const { setMessage } = useContext(AppContext);
  const [form, setForm] = useState(emptyAwardForm);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onChange = (field: keyof typeof form, value: string) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!isAwardFormValid(form)) {
      setMessage({ type: "error", message: "لطفاً همه فیلدها را کامل کنید." });
      return;
    }

    setIsSubmitting(true);
    try {
      const payload: CreateAwardData = {
        title: form.title.trim(),
        type: form.type,
        rank: Number(form.rank),
      };

      const response = await gameRepo.createAward(payload);
      if (!response.status) {
        setMessage({ type: "error", message: response.message || "ایجاد جایزه ناموفق بود." });
        return;
      }

      setMessage({ type: "success", message: "جایزه با موفقیت ایجاد شد." });
      navigate("/admin/awards");
    } catch {
      setMessage({ type: "error", message: "خطا در ارتباط با سرور. دوباره تلاش کنید." });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="space-y-4">
      <AdminPageTitle title="ایجاد جایزه" />
      <div className="rounded-2xl border border-slate-800 bg-slate-900/60 p-6">
        <form onSubmit={onSubmit} className="grid gap-4 md:grid-cols-2">
          <AwardFormFields form={form} onChange={onChange} />
          <div className="flex items-center gap-3 md:col-span-2">
            <button
              type="submit"
              disabled={!isAwardFormValid(form) || isSubmitting}
              className="rounded-lg bg-indigo-500 px-4 py-2 text-sm font-medium text-white transition hover:bg-indigo-400 disabled:cursor-not-allowed disabled:opacity-50"
            >
              {isSubmitting ? "در حال ایجاد…" : "ایجاد جایزه"}
            </button>
            <Link
              to="/admin/awards"
              className="inline-flex rounded-lg border border-slate-700 px-4 py-2 text-sm text-slate-200 transition hover:border-indigo-400 hover:text-indigo-300"
            >
              انصراف
            </Link>
          </div>
        </form>
      </div>
    </section>
  );
}
